export default class ApiError extends Error {
  status: number;

  errors: string[];

  response: any;

  link?: {
    label: string;
    url: string;
  };

  constructor(message: string, status: number, errors: string[], response: any) {
    super(message);
    this.status = status;
    this.errors = errors;
    this.response = response;
    this.link = response.link;
    Object.setPrototypeOf(this, ApiError.prototype);
  }
}
